export default __webpack_public_path__ + "70657687399cbb505a8bfafd17714615.svg";